const CreateUser_mutate = `
    mutation createUser(
      $email: String!,
      $tenantName: String!,
      $firstName: String!,
      $lastName: String!,
	  $password: String!,
      $repeatPassword: String!) {
      createUser(
        email: $email,
        tenantName: $tenantName,
        firstName: $firstName,
        lastName: $lastName,
		    password: $password,
        repeatPassword: $repeatPassword) {
        userId
		email
		password
        repeatPassword
        tenantName
      }
    }
`;

const CreatePublicUser_mutate = `
  mutation createPublicUser(
    $email: String!,
    $firstName: String, 
    $lastName: String,
    $phoneNo: String,
    $city: String,
    $state: String, 
    $country: String,
    $termId: Int!,
    $linkedinUrl: String) {
    createPublicUser(
      email: $email,
      firstName: $firstName,
      lastName: $lastName,
      phoneNo: $phoneNo,
      city: $city,
      state: $state,
      country: $country,
      termId: $termId,
      linkedinUrl: $linkedinUrl) {
      userId
      applicantId
      email      
      firstName
      lastName
      phoneNo
      city
      state
      country
      termId
      linkedinUrl
    }
  }
`;

const GetUserDataByUsername_query = `
  query( $username: String!)
  {
    getUserDataByUsername(username: $username)
    {
      firstName
      lastName
      email
      phoneNo
      city
      state
      country
    }
  }    
`;

const EditUser_mutate = `
  mutation editUser(
    $username: String!,    
    $firstName: String!,
    $lastName: String!,
    $email: String!,
    $phoneNo: String,
    $city: String,
    $state: String,
    $country: String) {
    editUser(
      username: $username,  
      firstName: $firstName,
      lastName: $lastName,
      email: $email,      
      phoneNo: $phoneNo,
      city: $city,
      state: $state,
      country: $country) 
      {
        user{
          username  
          firstName
          lastName
          email      
          phoneNo
          city
          state
          country
        }
      }
    }
`;

const ResendActivationEmail_mutate = `
  mutation resendActivationEmail(
    $username: String!,
    $tenantId: Int!) {
    resendActivationEmail(
      username: $username,
      tenantId: $tenantId) 
      {
        user{
          username  
          firstName
          lastName
          email      
          phoneNo
          city
          state
          country
        }
      }
    }
`;

module.exports = {
  CREATE_USER_MUTATION: CreateUser_mutate,
  CREATE_PUBLIC_USER_MUTATION: CreatePublicUser_mutate,
  GET_USER_DATA_BY_USERNAME: GetUserDataByUsername_query,
  EDIT_USER_MUTATION: EditUser_mutate,
  RESEND_ACTIVATION_EMAIL_MUTATION: ResendActivationEmail_mutate,
};
